// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface SpeakerVolumeIncreaseIconSignature {
  Element: SVGSVGElement;
}

export const SpeakerVolumeIncreaseIcon: TOC<SpeakerVolumeIncreaseIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.764 4.152C11.025 3.846 10.149 4.021 9.586 4.586L6.479 9H4C2.897 9 2 9.898 2 11V15C2 16.103 2.897 17 4 17H6.479L9.474 21.28C9.89 21.776 10.433 22 11 22C11.263 22 11.521 21.949 11.764 21.849C12.515 21.54 13 20.813 13 20V6C13 5.187 12.515 4.462 11.764 4.152ZM7.521 15H4V11H7.521L11 6.027L11.001 19.975L7.521 15ZM20 12H23V14H20V17H18V14H15V12H18V9H20V12Z"/>
</svg>
</template>;